import React from 'react'
import { NavLink, useHistory, useLocation } from 'react-router-dom'
import { LogoutOutlined } from '@ant-design/icons'
import { Button, Menu } from 'antd'
import { includes, map, find } from 'lodash-es'

import Logo from './logo'
import { NavigationBar as NavigationBarContainer } from './styled'

const navigationTabs = [
  {
    name: 'Test cases',
    link: '/scraping/test-cases/management',
    key: '/scraping/test-cases',
  },
  {
    name: 'Tags',
    link: '/scraping/tags/management',
    key: '/scraping/tags',
  },
  {
    name: 'Sessions',
    link: '/scraping/sessions/management',
    key: '/scraping/sessions',
  },
]

const renderNavigationTabs = (navigationTabs, history) =>
  map(navigationTabs, ({ link, key, name }) => (
    <Menu.Item key={key} onClick={() => history.push(link)}>
      {name}
    </Menu.Item>
  ))

const NavigationBar = () => {
  const { pathname } = useLocation()

  const selectedKey = find(navigationTabs, ({ key }) => includes(pathname, key))
    ?.key

  const history = useHistory()

  return (
    <NavigationBarContainer>
      <Menu mode="horizontal" selectedKeys={[selectedKey]}>
        <Logo />
        {renderNavigationTabs(navigationTabs, history)}
      </Menu>
      <Menu mode="horizontal" selectedKeys={[selectedKey]}>
        <Menu.Item key="logout">
          <NavLink to="/account/logout">
            <Button icon={<LogoutOutlined />} style={{ border: 'none' }}>
              Logout
            </Button>
          </NavLink>
        </Menu.Item>
      </Menu>
    </NavigationBarContainer>
  )
}
export default NavigationBar
